export const FORM_ICONS = {
  urlResolver: (i) => {
    return require(`./svgs/ic_${i}.svg`)
  },
  icons: [
    'seat',
    'add_rounded',
    'arrow_left',
    'arrow_right',
    'bed',
    'calendar',
    'calendar_bolder',
    'checkbox_checked',
    'checkbox',
    'close_rounded_nobg',
    'close_rounded',
    'close',
    'halfstar_on',
    'heart',
    'heart_on',
    'hotel_blue',
    'person',
    'place_blue',
    'place',
    'radio_checked',
    'radio',
    'search',
    'filter',
    'spin',
    'filled_spin',
    'photo',
    'region_pin',
    'recommend',
    'star_off',
    'star_on',
    'swiper_arrow_right',
    'swiper_arrow_left',
    'prev',
    'photo_gallery',
    'open_link',
    'train',
    'plane',
    'sideways_plane',
    'ship',
    'car',
    'parking',
    'shuttle',
    'ofuro',
    'meal',
    'favorite',
    'favorite_off',
    'adults',
    'location',
    'tripadvisor-0.0',
    'tripadvisor-0.5',
    'tripadvisor-1.0',
    'tripadvisor-1.5',
    'tripadvisor-2.0',
    'tripadvisor-2.5',
    'tripadvisor-3.0',
    'tripadvisor-3.5',
    'tripadvisor-4.0',
    'tripadvisor-4.5',
    'tripadvisor-5.0',
  ],
  alts: {
    seat: 'アイコン',
    add_rounded: 'アイコン',
    arrow_left: 'アイコン',
    arrow_right: 'アイコン',
    bed: 'アイコン',
    calendar: 'アイコン',
    checkbox_checked: '',
    checkbox: 'アイコン',
    close_rounded_nobg: 'アイコン',
    close_rounded: 'アイコン',
    close: 'アイコン',
    hotel_blue: 'アイコン',
    person: 'アイコン',
    place_blue: 'アイコン',
    place: 'アイコン',
    radio_checked: 'アイコン',
    radio: 'アイコン',
    search: 'こアイコン',
  },
}
